import { Dispatch } from "redux";
import {
    patchConditionalRebatesHandRaisersRequest,
    patchConditionalRebatesHandRaisersSuccess,
    patchConditionalRebatesHandRaisersFailure,
    getConditionalRebatesRequest,
    getConditionalRebatesSuccess,
    getConditionalRebatesFailure,
    putConditionalRebatesRequest,
    putConditionalRebatesSuccess,
    putConditionalRebatesFailure,
    deleteConditionalRebatesRequest,
    deleteConditionalRebatesSuccess,
    deleteConditionalRebatesFailure,
} from "src/store/actions/conditionalRebates";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { deleteTo, getFromAuthed, patchTo, putTo } from "src/store/dataService/routes/shared/osfetch";
import { findRoute } from "src/store/dataService/routes/util";

const getConditionalRebates = async (
    next: Dispatch,
    { payload: { uuid } }: ActionType<typeof getConditionalRebatesRequest>
) => {
    const response = await getFromAuthed(`/deals/${uuid}/vehicles/conditional-rebates`, next, false);

    if (response.ok && response.status === 200) {
        next(getConditionalRebatesSuccess(await response.json()));
        return;
    }

    next(getConditionalRebatesFailure());
};

const putConditionalRebates = async (
    next: Dispatch,
    { payload: { conditionalRebate, uuid } }: ActionType<typeof putConditionalRebatesRequest>
) => {
    try {
        const response = await putTo(`/deals/${uuid}/person/conditional_rebates`, conditionalRebate, next);

        if (response.ok) {
            next(putConditionalRebatesSuccess());
        } else {
            next(putConditionalRebatesFailure(conditionalRebate));
        }
    } catch (e) {
        next(putConditionalRebatesFailure(conditionalRebate));
    }
};

const deleteConditionalRebates = async (
    next: Dispatch,
    { payload: { conditionalRebate, uuid } }: ActionType<typeof deleteConditionalRebatesRequest>
) => {
    try {
        const response = await deleteTo(
            `/deals/${uuid}/person/conditional_rebates/${conditionalRebate.id}${
                conditionalRebate.subcategory ? `?subcategory=${conditionalRebate.subcategory}` : ``
            }`,
            next
        );

        if (response.ok) {
            next(deleteConditionalRebatesSuccess());
        } else {
            next(deleteConditionalRebatesFailure(conditionalRebate));
        }
    } catch (e) {
        next(deleteConditionalRebatesFailure(conditionalRebate));
    }
};

const patchConditionalRebatesHandRaisers = async (
    next: Dispatch,
    { payload: { id, value, uuid } }: ActionType<typeof patchConditionalRebatesHandRaisersRequest>
) => {
    try {
        const response = await patchTo(`/deals/${uuid}/rebates`, { [id]: value }, next);

        if (response.ok) {
            next(patchConditionalRebatesHandRaisersSuccess());
        } else {
            next(patchConditionalRebatesHandRaisersFailure(id, !value));
        }
    } catch (e) {
        next(patchConditionalRebatesHandRaisersFailure(id, !value));
    }
};

const routes = {
    [getConditionalRebatesRequest.type]: getConditionalRebates,
    [putConditionalRebatesRequest.type]: putConditionalRebates,
    [deleteConditionalRebatesRequest.type]: deleteConditionalRebates,
    [patchConditionalRebatesHandRaisersRequest.type]: patchConditionalRebatesHandRaisers,
};

export default (next: Dispatch, action: any) => findRoute(routes)(next, action);
